"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _AsyncBoundary;
const _excluded = ["label", "icon", "iconSrc", "iconColour", "to", "AuthedOverlay", "Component", "checkIsVisible", "IfAuthedComponent", "fullWidth", "target", "isLink"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { logout } from '@autoguru/auth';
import { IS_PRODUCTION } from '@autoguru/global-configs';
import { useMfeTranslation } from '@autoguru/i18n';
import { PowerIcon } from '@autoguru/icons';
import { Box, Stack, Text } from '@autoguru/overdrive';
import { AsyncBoundary } from '@autoguru/suspense';
import { lazy, useCallback, useMemo } from 'react';
import { useExpandSideNav } from '../ExpandSideNavProvider';
import * as styles from './ExpandSideNavLinks.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ExpandCopyAccessToken = /*#__PURE__*/lazy(async () => import('../ExpandCopyAccessToken'));
const ExpandSideNavMobileLink = /*#__PURE__*/lazy(async () => import('../ExpandSideNavMobileLink/ExpandSideNavMobileLink'));
const ExpandSideNavLink = /*#__PURE__*/lazy(async () => import('../ExpandSideNavLink/ExpandSideNavLink'));
const replaceToken = (value, token, tokenValue) => value.replaceAll(`#[${token}\]`, tokenValue);
const hasUnresolvedToken = value => /(\#\[.*\])/.test(value);
const ExpandLinkGroup = ({
  label,
  links,
  labelClassName,
  stringTokens,
  activeLinkChecker,
  isAuthed,
  viewerAccess,
  layout
}) => {
  const linkParser = useCallback(link => {
    if (!link) return null;
    let processedLink = link;
    if (stringTokens) {
      for (const token of Object.keys(stringTokens)) {
        processedLink = replaceToken(processedLink, token, stringTokens[token]);
      }
    }
    return processedLink;
  }, [stringTokens]);
  const isActiveChecker = useCallback(link => typeof activeLinkChecker === 'function' ? activeLinkChecker(link) : location.href.startsWith(link), [activeLinkChecker]);
  return /*#__PURE__*/_jsxs(Stack, {
    as: "nav",
    space: "none",
    children: [label ? /*#__PURE__*/_jsx(Text, {
      size: "2",
      transform: "uppercase",
      colour: "muted",
      children: label
    }) : null, useMemo(() => links.filter(({
      requiredAccess
    }) => !requiredAccess || viewerAccess.includes(requiredAccess)).map((_ref, index) => {
      let {
          label,
          icon,
          iconSrc,
          iconColour,
          to,
          AuthedOverlay,
          Component,
          checkIsVisible,
          IfAuthedComponent,
          fullWidth,
          target,
          isLink = true
        } = _ref,
        linkProps = _objectWithoutProperties(_ref, _excluded);
      const link = linkParser(to);
      const props = isLink ? {
        to: link
      } : {
        onClick: () => window.open(link, 'SupplierPortalLegacy', 'popup')
      };
      return (
        /*#__PURE__*/
        // biome-ignore lint/suspicious/noArrayIndexKey: migration quick fix. To be fixed when code is touched
        _jsx(AsyncBoundary, {
          fallback: null,
          errorFallback: null,
          children: /*#__PURE__*/_jsx(ExpandSideNavLink, _objectSpread(_objectSpread(_objectSpread({
            isAuthed: isAuthed,
            checkIsVisible: checkIsVisible,
            labelClassName: labelClassName,
            label: label,
            icon: icon,
            iconSrc: iconSrc,
            iconColour: iconColour,
            Component: Component,
            IfAuthedComponent: IfAuthedComponent,
            AuthedOverlay: AuthedOverlay,
            fullWidth: fullWidth,
            target: target,
            layout: layout,
            disabled: hasUnresolvedToken(link)
          }, props), linkProps), {}, {
            isActive: isActiveChecker(to)
          }))
        }, index)
      );
    }), [links, linkParser, viewerAccess, isActiveChecker, labelClassName, isAuthed, layout])]
  });
};
const ExpandLinkGroupMobileView = ({
  label,
  links,
  labelClassName,
  stringTokens,
  activeLinkChecker,
  isAuthed,
  viewerAccess,
  showItemFullWidth,
  layout: _layout
}) => {
  const linkParser = useCallback(link => {
    if (!link) return null;
    let processedLink = link;
    if (stringTokens) {
      for (const token of Object.keys(stringTokens)) {
        processedLink = replaceToken(processedLink, token, stringTokens[token]);
      }
    }
    return processedLink;
  }, [stringTokens]);
  const isActiveChecker = useCallback(link => typeof activeLinkChecker === 'function' ? activeLinkChecker(link) : location.href.startsWith(link), [activeLinkChecker]);
  return /*#__PURE__*/_jsxs(Box, {
    as: "nav",
    display: "grid",
    className: showItemFullWidth ? styles.navItemsMobileFullWidth : styles.navItemsMobile,
    paddingX: "3",
    children: [label ? /*#__PURE__*/_jsx(Text, {
      size: "2",
      transform: "uppercase",
      colour: "muted",
      children: label
    }) : null, useMemo(() => links.filter(({
      requiredAccess
    }) => !requiredAccess || viewerAccess.includes(requiredAccess)).map(({
      label,
      icon,
      iconSrc,
      iconColour,
      to,
      AuthedOverlay,
      Component,
      checkIsVisible,
      IfAuthedComponent,
      fullWidth,
      target,
      isLink: _isLink = true
    }, index) => {
      const link = linkParser(to);
      const props = _isLink ? {
        to: link
      } : {
        onClick: () => window.open(link, 'SupplierPortalLegacy', 'popup')
      };
      return (
        /*#__PURE__*/
        // biome-ignore lint/suspicious/noArrayIndexKey: migration quick fix. To be fixed when code is touched
        _jsx(AsyncBoundary, {
          fallback: null,
          errorFallback: null,
          children: /*#__PURE__*/_jsx(ExpandSideNavMobileLink, _objectSpread(_objectSpread({
            isAuthed: isAuthed,
            checkIsVisible: checkIsVisible,
            labelClassName: labelClassName,
            label: label,
            icon: icon,
            iconSrc: iconSrc,
            iconColour: iconColour,
            Component: Component,
            IfAuthedComponent: IfAuthedComponent,
            AuthedOverlay: AuthedOverlay,
            fullWidth: fullWidth,
            target: target,
            disabled: hasUnresolvedToken(link)
          }, props), {}, {
            isActive: isActiveChecker(to)
          }))
        }, index)
      );
    }), [links, linkParser, viewerAccess, isActiveChecker, labelClassName, isAuthed])]
  });
};
export const ExpandSideNavLinks = ({
  className: _className = '',
  isAuthed,
  layout,
  minHeight
}) => {
  var _asideItems$header, _asideItems$body, _asideItems$footer;
  const {
    t
  } = useMfeTranslation('pkg-expand-side-nav');
  const {
    asideItems,
    includeAuth,
    labelClassName,
    stringTokens,
    viewerAccess,
    logoutRedirect,
    logoutUrl,
    activeLinkChecker
  } = useExpandSideNav({});
  const onRequestLogout = useCallback(() => {
    if (logoutUrl) {
      const newTab = window.open(logoutUrl, '_blank');
      const listener = event => {
        if (event.data === 'logged-out') {
          newTab.close();
          logout(logoutRedirect);
          window.removeEventListener('message', listener);
        }
      };
      window.addEventListener('message', listener);
    } else logout(logoutRedirect);
  }, [logoutRedirect, logoutUrl]);
  return /*#__PURE__*/_jsxs(Box, {
    as: "aside",
    width: "full",
    className: [_className, styles.root],
    style: {
      minHeight
    },
    children: [/*#__PURE__*/_jsxs(Stack, {
      space: "2",
      children: [(_asideItems$header = asideItems.header) !== null && _asideItems$header !== void 0 && _asideItems$header.length ? /*#__PURE__*/_jsx(_Fragment, {
        children: layout === 'desktop' ? /*#__PURE__*/_jsx(Stack, {
          dividers: true,
          as: "ul",
          space: "4",
          children: asideItems.header.map(({
            label,
            links
          }, index) => {
            var _links$;
            return /*#__PURE__*/_jsx(ExpandLinkGroup, {
              isAuthed: isAuthed,
              labelClassName: labelClassName,
              label: label,
              links: links,
              viewerAccess: viewerAccess,
              stringTokens: stringTokens,
              activeLinkChecker: activeLinkChecker,
              layout: layout
            }, `${label}-${((_links$ = links[0]) === null || _links$ === void 0 ? void 0 : _links$.to) || index}`);
          })
        }) : /*#__PURE__*/_jsx(Stack, {
          dividers: true,
          as: "ul",
          space: "4",
          children: asideItems.header.map(({
            label,
            links
          }, index) => {
            var _links$2;
            return /*#__PURE__*/_jsx(ExpandLinkGroupMobileView, {
              isAuthed: isAuthed,
              labelClassName: labelClassName,
              label: label,
              links: links,
              viewerAccess: viewerAccess,
              stringTokens: stringTokens,
              activeLinkChecker: activeLinkChecker,
              showItemFullWidth: true,
              layout: layout
            }, `${label}-${((_links$2 = links[0]) === null || _links$2 === void 0 ? void 0 : _links$2.to) || index}`);
          })
        })
      }) : null, (_asideItems$body = asideItems.body) !== null && _asideItems$body !== void 0 && _asideItems$body.length ? layout === 'desktop' ? /*#__PURE__*/_jsx(Stack, {
        dividers: true,
        as: "ul",
        space: "4",
        children: asideItems.body.map(({
          label,
          links
        }, index) => {
          var _links$3;
          return /*#__PURE__*/_jsx(ExpandLinkGroup, {
            isAuthed: isAuthed,
            labelClassName: labelClassName,
            label: label,
            links: links,
            viewerAccess: viewerAccess,
            stringTokens: stringTokens,
            activeLinkChecker: activeLinkChecker,
            layout: layout
          }, `${label}-${((_links$3 = links[0]) === null || _links$3 === void 0 ? void 0 : _links$3.to) || index}`);
        })
      }) : /*#__PURE__*/_jsx(Stack, {
        dividers: true,
        as: "ul",
        space: "4",
        children: asideItems.body.map(({
          label,
          links
        }, index) => {
          var _links$4;
          return /*#__PURE__*/_jsx(ExpandLinkGroupMobileView, {
            isAuthed: isAuthed,
            labelClassName: labelClassName,
            label: label,
            links: links,
            viewerAccess: viewerAccess,
            stringTokens: stringTokens,
            activeLinkChecker: activeLinkChecker,
            layout: layout
          }, `${label}-${((_links$4 = links[0]) === null || _links$4 === void 0 ? void 0 : _links$4.to) || index}`);
        })
      }) : null]
    }), (_asideItems$footer = asideItems.footer) !== null && _asideItems$footer !== void 0 && _asideItems$footer.length ? /*#__PURE__*/_jsx(Stack, {
      dividers: true,
      as: "ul",
      space: "4",
      children: asideItems.footer.map(({
        label,
        links
      }, index) => {
        var _links$5;
        return /*#__PURE__*/_jsx(ExpandLinkGroup, {
          isAuthed: isAuthed,
          labelClassName: labelClassName,
          viewerAccess: viewerAccess,
          stringTokens: stringTokens,
          activeLinkChecker: activeLinkChecker,
          label: label,
          links: links,
          layout: layout
        }, `${label}-${((_links$5 = links[0]) === null || _links$5 === void 0 ? void 0 : _links$5.to) || index}`);
      })
    }) : null, /*#__PURE__*/_jsxs(Stack, {
      space: "none",
      children: [!isAuthed || !includeAuth || JSON.parse(IS_PRODUCTION) ? null : _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: null,
        errorFallback: null,
        children: /*#__PURE__*/_jsx(ExpandCopyAccessToken, {})
      }, "access-token")), isAuthed && includeAuth && /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: null,
        errorFallback: null,
        children: /*#__PURE__*/_jsx(ExpandSideNavLink, {
          labelClassName: labelClassName,
          label: t('logout'),
          to: null,
          icon: PowerIcon,
          isAuthed: isAuthed,
          onClick: onRequestLogout,
          isActive: false,
          layout: layout
        })
      }, "logout")]
    })]
  });
};